<template>
  <div >
   <div class="main">
    <img  src="static/img/act/3/top.jpg?v=3" />
    <div class="act-3-main" style="margin-top: -1px;background-image: url(static/img/act/3/bg.jpg);">
        <img  src="static/img/act/3/title-1.png" style="position:absolute;left:16%;top:0;width: 71%;"/>
        
        <div style="text-align: center;">
        <img  src="static/img/act/3/btn-down.png" class="act-3-btn-down" @click="displayAct3Desc()"  v-bind:class="{act2down:isActt3DescClass,act2downno:!isActt3DescClass}"/>
        </div> 
      <div class="act-3-desc" style="font-size: 0.26rem;color: #0d0e10; width: 100%;overflow: hidden;" v-bind:style="{height: actt3DescHeight }">
        <div class="act-3-desc-content" style="background-color: #024160; color: #FFFFFF;    margin: 3% 5% 3% 5%;padding: 5%;    width: 80%; border-radius: 15px;" >
          <div style="overflow: scroll;width: 100%; margin: auto;height:180px">
            <img src="static/img/act/3/title-contents.png" style="width:96%;margin: auto;">        
          </div>
        </div>
      </div>
        <!-- 内容  1-->
        <div class="act-3-contents-1" v-bind:style="{height: actt3Contents1Height}" style="overflow: hidden;margin-top: 20px;">
          <img  src="static/img/act/3/z-1-contents.png?v=4" style="width: 100%;"/>          
        </div>
        <div style="text-align: center;">
          <img  src="static/img/act/3/btn-down.png" class="act-3-btn-down" style="margin-top: 5%;"  @click="displayAct3Contents()"  v-bind:class="{act2down:isActt3Contents1Class,act2downno:!isActt3Contents1Class}"/>
        </div>
        <!-- 内容  1 end -->
        
        <!-- 轮播图 1 -->
        <div class="act-3-banner-1">
          <div class="swiper-container act-3-swiper-1">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/1.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/2.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/3.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/4.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/5.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/6.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/7.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/8.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/1/9.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
            </div>
            <!-- Add Arrows -->
            <div class="swiper-button-next" @click="acT3Banner1Next()">
              
            </div>
            <div class="swiper-button-prev" @click="acT3Banner1Prev()">
              
            </div>
          </div> 
        </div>
        <!-- 轮播图 1 end-->
        
        
        <!-- 内容  2-->
        <div class="act-3-contents-2">
         <img  src="static/img/act/3/z-2-contents.png?v=4" style="width: 100%;"/>          
        </div>
        <!-- 内容  2 end -->
        
        
        <!-- 轮播图 2 -->
        <div class="act-3-banner-2">
          <div class="swiper-container act-3-swiper-2">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/1.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/2.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/3.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/4.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/5.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/6.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/7.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/8.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/9.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/10.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/11.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/12.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/13.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/14.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/15.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/2/16.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
            </div>
            <!-- Add Arrows -->
            <div class="swiper-button-next" @click="acT3Banner2Next()">
              
            </div>
            <div class="swiper-button-prev" @click="acT3Banner2Prev()">
              
            </div>
          </div> 
        </div>
        <!--   轮播图 2 end-->
        
        <!-- 内容  3-->
         <div class="act-3-contents-3" v-bind:style="{height: actt3Contents3Height}" style="overflow: hidden;margin-top: 45px;">
          <img  src="static/img/act/3/z-3-contents.png" style="width: 100%;"/>          
        </div>
        <div style="text-align: center;">
          <img  src="static/img/act/3/btn-down.png" class="act-3-btn-down" style="margin-top: 5%;"  @click="displayAct3Contents3()"  v-bind:class="{act2down:isActt3Contents3Class,act2downno:!isActt3Contents3Class}"/>
        </div>
        <!-- 内容  3 end -->
        
        
        <!-- 轮播图 3 -->
        <div class="act-3-banner-3">
          <div class="swiper-container act-3-swiper-3">
            <div class="swiper-wrapper">
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/3/1.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/3/2.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/3/3.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/3/4.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/3/5.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
              </div>
              <div class="swiper-slide">
                <img class="swiper-lazy" data-src="static/img/act/3/banner/3/6.jpg?v=2">
                <div class="swiper-lazy-preloader"></div>
                
              </div>
            </div>
            <!-- Add Arrows -->
            <div class="swiper-button-next" @click="acT3Banner3Next()">
              
            </div>
            <div class="swiper-button-prev" @click="acT3Banner3Prev()">
              
            </div>
          </div> 
        </div>
        <!--   轮播图 3 end-->
        
        <img  src="static/img/act/3/footer.png" style="margin-top: 20px;"/>
      </div>  
    </div>
      
    <!-- 底部导航 -->  
    <nav-tabbar ></nav-tabbar>
    <!-- 底部导航 end--> 
  </div>
</template>

<script> 
  import NavTabbar from '@/components/NavTabbar.vue' 
  //轮播
  import Swiper from 'swiper' 
  import 'swiper/dist/css/swiper.min.css'
  
  export default {
    name: 'Act3Main',
    components: { 
      'nav-tabbar': NavTabbar,  
    },
    data() {
      return {  
        
     
      actt3DescHeight:'220px',
      isActt3DescClass:false,
      
      actt3Contents1Height:'89px',
      actt3Contents1BeginHeight:'89px',
      actt3Contents1EndHeight:'89px',
      
      isActt3Contents1Class:false,
      
      act3Swiper1:'',
      act3Swiper2:'',
      act3Swiper3:'',
      
      
      actt3Contents3Height:'89px',
      actt3Contents3BeginHeight:'89px',
      actt3Contents3EndHeight:'89px',
      isActt3Contents3Class:false,
      
      }
    },
    mounted() {      
      this.c("搞-act-3",'!!!!!!!!!!')
      this.$emit('firstLoad')
      
      let w = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
    let h = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
    let elementWith = (w*0.1826);
    if(w>=750){
      elementWith = 137;
      w= 750;
    }
    
      this.act3Swiper1 = new Swiper('.act-3-swiper-1', {
            autoplay:false,
            loop:true, 
            lazy: {
    loadPrevNext: true,
  }
          })
     this.act3Swiper2 = new Swiper('.act-3-swiper-2', {
            autoplay:false,
            loop:true, lazy: {
    loadPrevNext: true,
  }
          })
    
     this.act3Swiper3 = new Swiper('.act-3-swiper-3', {
            autoplay:false,
            loop:true, lazy: {
    loadPrevNext: true,
  }
          })
     
     this.actt3Contents1BeginHeight = w * 0.4146666666666667 * 0.6809646302250804+ 'px'
   this.actt3Contents1Height = w * 0.4146666666666667 * 0.6809646302250804+ 'px'
   this.actt3Contents1EndHeight  = w * 0.4146666666666667 + 'px'
    
   this.actt3Contents3BeginHeight = w * 0.5106666666666667 * 0.5639686684073107+ 'px'
   this.actt3Contents3Height = w * 0.5106666666666667 * 0.5639686684073107  + 'px'   
   this.actt3Contents3EndHeight  = w * 0.5106666666666667 + 'px'
   
      
    },
    created() {
      //站点设置
      this.setDocumentV2(
        "三江侗族大歌节",
        "",
        "https://z.lzgd.com.cn/inliuzhou/2018/LiuzhouTourism/img/share.jpg?v=2"
      );
      _czc.push(['_trackEvent', '三江侗族大歌节', '点击', '主页面','0','3']);
      //移除loading
      this.removeLoader()
    },
    methods: {  
      
      displayAct3Desc(){ 
        if(this.actt3DescHeight=='220px'){
          this.actt3DescHeight = "0px"
          this.isActt3DescClass = false
        }else{
          this.actt3DescHeight = "220px"
          this.isActt3DescClass = true
        }
      },
      displayAct3Contents(){        
        if(this.actt3Contents1Height == this.actt3Contents1EndHeight){
          this.actt3Contents1Height = this.actt3Contents1BeginHeight
          this.isActt3Contents1Class = false
        }else{
          this.actt3Contents1Height = this.actt3Contents1EndHeight
          this.isActt3Contents1Class = true
        }
      },
      displayAct3Contents3(){        
        if(this.actt3Contents3Height == this.actt3Contents3EndHeight){
          this.actt3Contents3Height = this.actt3Contents3BeginHeight
          this.isActt3Contents3Class = false
        }else{
          this.actt3Contents3Height = this.actt3Contents3EndHeight
          this.isActt3Contents3Class = true
        }
      },
      acT3Banner1Next(){
        try{
          this.act3Swiper1[1].slideNext();
        }catch(e){
           try{
          this.act3Swiper1[0].slideNext();
          
          
        }catch(e){
          this.act3Swiper1.slideNext();
        }
        }
       
      },
      acT3Banner1Prev(){
        
        try{
          this.act3Swiper1[1].slidePrev();
        }catch(e){
           try{
          this.act3Swiper1[0].slidePrev();
          
          
        }catch(e){
          this.act3Swiper1.slidePrev();
        }
        }
      },
      acT3Banner2Next(){
       
        
         try{
          this.act3Swiper2[1].slideNext();
        }catch(e){
           try{
          this.act3Swiper2[0].slideNext();
          
          
        }catch(e){
          this.act3Swiper2.slideNext();
        }
        }
        
        
      },
      acT3Banner2Prev(){ 
        
        try{
          this.act3Swiper2[1].slidePrev();
        }catch(e){
           try{
          this.act3Swiper2[0].slidePrev();
          
          
        }catch(e){
          this.act3Swiper2.slidePrev();
        }
        }
        
      },
      acT3Banner3Next(){ 
        
        try{
          this.act3Swiper3[1].slideNext();
        }catch(e){
           try{
          this.act3Swiper3[0].slideNext();
          
          
        }catch(e){
          this.act3Swiper3.slideNext();
        }
        }
        
      },
      acT3Banner3Prev(){ 
        
        
        try{
          this.act3Swiper3[1].slidePrev();
        }catch(e){
           try{
          this.act3Swiper3[0].slidePrev();
          
          
        }catch(e){
          this.act3Swiper3.slidePrev();
        }
        }
        
      }
  }}
    
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped> 
  .main{
    position: absolute;
    width: 100%;
    height: 100%;
    font-size: 0;
  }
  .main img{
    width: 100%;
  }
  .act-3-desc {
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}

.act2down {
  transform: rotate(180deg);
  -webkit-transform: rotate(180deg);
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}

.act2downno {
  transform: rotate(0deg);
  -webkit-transform: rotate(0deg);
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}
/* id-3  */
.act-3-btn-down{
  margin-top: 13%;
  width: 6% !important;
  text-align: center;
}
.act3 img{
  width: 100%;  
}
.act-3-main{
  position: relative;
  width: 100%;  
  min-height: 300px;
 
  background-size: 100% auto;
}


.act-3-desc-content::-webkit-scrollbar {
  width: 7px;
  /*滚动条宽度*/
  height: 7px;
  /*滚动条高度*/
}


/*定义滚动条轨道 内阴影+圆角*/

.act-3-desc-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
  /*滚动条的背景区域的圆角*/
  background-color: rgba(111, 111, 111, 1);
  /*滚动条的背景颜色*/
}


/*定义滑块 内阴影+圆角*/

.act-3-desc-content::-webkit-scrollbar-thumb {
  border-radius: 10px;
  /*滚动条的圆角*/
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
  background-color: #FFFFFF;
  /*滚动条的背景颜色*/
}

.act-3-contents-1 {
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}
.act-3-banner-1{
  margin-top: 20px;
}
.swiper-button-next, .swiper-container-rtl .swiper-button-prev{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M27%2C22L27%2C22L5%2C44l-2.1-2.1L22.8%2C22L2.9%2C2.1L5%2C0L27%2C22L27%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") !important;  
}
.swiper-button-prev, .swiper-container-rtl .swiper-button-next{
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D'http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg'%20viewBox%3D'0%200%2027%2044'%3E%3Cpath%20d%3D'M0%2C22L22%2C0l2.1%2C2.1L4.2%2C22l19.9%2C19.9L22%2C44L0%2C22L0%2C22L0%2C22z'%20fill%3D'%23ffffff'%2F%3E%3C%2Fsvg%3E") !important;  
}
.swiper-lazy-preloader{
      margin-top: 26% !important;
}

.act-3-contents-2{
  margin-top: 20px;
}
 

.act-3-banner-2{
  margin-top: 20px;
}
.act-3-banner-3{
  margin-top: 20px;  
}
.act-3-contents-3 {
  -webkit-transition: all 300ms ease, transform 500ms ease;
  transition: all 300ms ease, transform 500ms ease;
}
</style>


// WEBPACK FOOTER //
// src/components/act/3/main.vue